import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'fly-footer',
  imports: [],
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  flyGarminVersion = input<string | undefined>();
}
